import { render, staticRenderFns } from "./CollaboratorContainer.vue?vue&type=template&id=0b34a82d&scoped=true&"
var script = {}
import style0 from "./CollaboratorContainer.vue?vue&type=style&index=0&id=0b34a82d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b34a82d",
  null
  
)

export default component.exports